import { createContext } from "react";
import { createDefaultContext } from "../../../helpers/createDefaultContext";

export type PopoverContextValue = {
  anchorRef?: React.RefObject<HTMLElement | null>;
  open: boolean;
  popoverId?: string;
  setOpen: (open: boolean) => void;
  triggerRef: React.RefObject<HTMLElement | null>;
};

export const PopoverContext = createContext<PopoverContextValue>(
  createDefaultContext(),
);
